module.exports = __webpack_public_path__ + "img/30_bohle.c90dcae3.jpeg";